export default __webpack_public_path__ + "static/media/entenda_3_pontape.45d3b786.jpg";